import "./App.css";

const IOS_URL = "https://apps.apple.com/us/app/weather-champs/id6651842782";
const ANDROID_URL =
  "https://play.google.com/store/apps/details?id=org.tc.weatherchamps&utm_source=na_Med";

function TrophyIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7">
      <path d="M6 9H4a2 2 0 0 1-2-2V5h4" />
      <path d="M18 9h2a2 2 0 0 0 2-2V5h-4" />
      <path d="M8 21h8" />
      <path d="M12 17v4" />
      <path d="M6 5h12v8a6 6 0 0 1-12 0V5z" />
    </svg>
  );
}

function MapPinIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7">
      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
      <circle cx={12} cy={10} r={3} />
    </svg>
  );
}

function CoinsIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7">
      <circle cx={8} cy={8} r={6} />
      <path d="M18.09 10.37A6 6 0 1 1 10.34 18" />
      <path d="M7 6h1v4" />
      <path d="m16.71 13.88.7.71-2.82 2.82" />
    </svg>
  );
}

function CloudIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7">
      <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" />
    </svg>
  );
}

function StarIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  );
}

function UsersIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx={9} cy={7} r={4} />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}

function AppleIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
      <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
    </svg>
  );
}

function PlayIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
      <path d="M3 20.5v-17c0-.83.94-1.3 1.6-.8l14 8.5c.6.36.6 1.24 0 1.6l-14 8.5c-.66.5-1.6.03-1.6-.8z" />
    </svg>
  );
}

const features = [
  {
    icon: <TrophyIcon />,
    title: "Daily Contests",
    desc: "Enter weather forecasting contests every day and compete for real prizes.",
  },
  {
    icon: <MapPinIcon />,
    title: "Your City, Your Game",
    desc: "Choose your local city or explore contests across hundreds of locations.",
  },
  {
    icon: <CoinsIcon />,
    title: "Win Real Prizes",
    desc: "Top forecasters earn cash prizes. The more accurate you are, the more you win.",
  },
  {
    icon: <CloudIcon />,
    title: "Live Weather Data",
    desc: "Powered by real-time weather data so every contest is fair and accurate.",
  },
  {
    icon: <StarIcon />,
    title: "Leaderboards",
    desc: "Climb the ranks and prove you're the best weather champ in your region.",
  },
  {
    icon: <UsersIcon />,
    title: "Community",
    desc: "Join thousands of weather enthusiasts competing across the country.",
  },
];

export default function App() {
  return (
    <div className="min-h-screen bg-[#0a0f1e] text-white">
      {/* ── HERO ── */}
      <div className="relative overflow-hidden">
        {/* background glow blobs */}
        <div className="pointer-events-none absolute -top-32 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-teal-500/20 blur-[120px]" />
        <div className="pointer-events-none absolute top-20 -right-24 w-[300px] h-[300px] rounded-full bg-cyan-400/10 blur-[80px]" />

        <div className="relative container max-w-7xl">
          {/* nav */}
          <header className="flex items-center justify-between py-7 sm:py-9">
            <div className="w-[68px] sm:w-[84px]">
              <img
                src="/assets/wcLogo.png"
                className="h-auto w-full object-contain"
                alt="Weather Champs"
                width={84}
                height={84}
              />
            </div>
            <a
              href={IOS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-full border border-white/20 bg-white/10 px-5 py-2 text-sm font-medium backdrop-blur-sm transition hover:bg-white/20"
            >
              Download Free
            </a>
          </header>

          {/* hero grid */}
          <div className="grid items-center gap-12 pb-16 sm:pb-24 md:grid-cols-2 md:gap-8 lg:gap-16">
            {/* left copy */}
            <div className="flex flex-col items-center gap-7 text-center md:items-start md:text-left">
              <div className="inline-flex items-center gap-2 rounded-full border border-teal-500/40 bg-teal-500/10 px-4 py-1.5 text-sm font-medium text-teal-300">
                <span className="inline-block h-2 w-2 rounded-full bg-teal-400 animate-pulse" />
                Free to Play · Win Real Prizes
              </div>

              <h1 className="text-5xl font-bold leading-[1.07] tracking-tight sm:text-6xl lg:text-7xl">
                Forecast the
                <span className="block bg-gradient-to-r from-teal-300 to-cyan-400 bg-clip-text text-transparent">
                  Weather.
                </span>
                Win Big.
              </h1>

              <p className="max-w-md text-base leading-relaxed text-slate-400 sm:text-lg">
                Weather Champs turns daily weather forecasting into a competitive
                sport. Pick your city, make your predictions, and climb the
                leaderboard to win cash prizes.
              </p>

              {/* CTA buttons */}
              <div className="flex flex-col items-center gap-3 sm:flex-row md:items-start">
                <a
                  href={IOS_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 rounded-full bg-white px-6 py-3.5 text-sm font-semibold text-slate-900 shadow-lg shadow-white/10 transition hover:bg-slate-100 hover:scale-[1.02] active:scale-100"
                >
                  <AppleIcon />
                  Download on the App Store
                </a>
                <a
                  href={ANDROID_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 rounded-full border border-white/20 bg-white/10 px-6 py-3.5 text-sm font-semibold backdrop-blur-sm transition hover:bg-white/20 hover:scale-[1.02] active:scale-100"
                >
                  <PlayIcon />
                  Get it on Google Play
                </a>
              </div>

              {/* store badge images */}
            
            </div>

            {/* right phone mockup */}
            <div className="flex justify-center md:justify-end">
              <div className="relative">
                {/* glow behind phone */}
                <div className="absolute inset-0   blur-3xl" />
                <div className="relative overflow-hidden rounded-[36px] shadow-2xl shadow-teal-500/20  max-w-[260px] sm:max-w-[300px]">
                  <img
                    src="/assets/wc-mobile-mock.svg"
                    className="h-full w-full object-cover"
                    alt="Weather Champs app preview"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── FEATURES ── */}
      <div className="border-t border-white/5 bg-[#0d1428]">
        <div className="container max-w-7xl py-20 sm:py-24">
          <div className="mb-14 text-center">
            <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">
              Why play Weather Champs?
            </h2>
            <p className="mt-3 text-slate-400 sm:text-lg">
              Everything you need to compete, win, and have fun with weather.
            </p>
          </div>

          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {features.map(({ icon, title, desc }) => (
              <div
                key={title}
                className="flex gap-4 rounded-2xl border border-white/8 bg-white/5 p-5 transition hover:border-teal-500/40 hover:bg-white/8"
              >
                <div className="mt-0.5 flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-teal-500/15 text-teal-400">
                  {icon}
                </div>
                <div>
                  <h3 className="font-semibold text-white">{title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-slate-400">{desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── BOTTOM CTA ── */}
      <div className="border-t border-white/5 bg-[#0a0f1e]">
        <div className="container max-w-7xl py-20 text-center">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">
            Ready to become a{" "}
            <span className="bg-gradient-to-r from-teal-300 to-cyan-400 bg-clip-text text-transparent">
              Weather Champ?
            </span>
          </h2>
          <p className="mx-auto mt-4 max-w-md text-slate-400">
            Download the app for free and start competing today.
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href={IOS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 rounded-full bg-teal-400 px-7 py-3.5 text-sm font-semibold text-slate-900 shadow-lg shadow-teal-500/25 transition hover:bg-teal-300 hover:scale-[1.02]"
            >
              <AppleIcon />
              App Store
            </a>
            <a
              href={ANDROID_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 rounded-full border border-white/20 bg-white/10 px-7 py-3.5 text-sm font-semibold backdrop-blur-sm transition hover:bg-white/20 hover:scale-[1.02]"
            >
              <PlayIcon />
              Google Play
            </a>
          </div>
        </div>
      </div>

      {/* ── FOOTER ── */}
      <footer className="border-t border-white/5 py-6 text-center text-xs text-slate-600">
        © {new Date().getFullYear()} Weather Champs. All rights reserved.
      </footer>
    </div>
  );
}
